import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useUsersList() {
  // Use toast
  const toast = useToast()

  const refUserListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'no', label: 'หมายเลขคำสั่งซื้อ', sortable: true },
    { key: 'createdOnString', label: 'วันที่สั่งซื้อ', sortable: true },
    { key: 'customerName', label: 'ชื่อ - นามสกุล', sortable: true },
    {
      key: 'customerPhone',
      label: 'เบอร์โทรศัพท์',
      formatter: title,
      sortable: true,
    },
    { key: 'orderTotal', label: 'ยอดรวมสินค้าทั้งหมด', sortable: true },
    { key: 'orderStatusString', label: 'สถานะคำสั่งซื้อ' },
    { key: 'status', label: 'สถานะ' },
    // { key: 'actions' },
  ]

  const tableProductColumn = [
    { key: 'productCode', label: 'รหัสสินค้า', sortable: true },
    { key: 'name', label: 'ชื่อสินค้า', sortable: true },
    { key: 'categoryName', label: 'ประเภทสินค้า', sortable: true },
    { key: 'shopName', label: 'ชื่อร้านค้า', sortable: true },
    {
      key: 'price',
      label: 'ราคาสินค้า',
      formatter: title,
      sortable: true,
    },
    { key: 'stockQuantity', label: 'สินค้าในสต๊อก', sortable: true },
    // { key: 'actions', label: 'ตัวเลือกสินค้า', sortable: true },
    {
      key: 'totalQuantity',
      label: 'ยอดขายสินค้า',

      sortable: true,
    },
    { key: 'isPublishedText', label: 'สถานะ' },
  ]

  const perPage = ref(10)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  const refetchData = () => {
    refUserListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter], () => {
    refetchData()
  })

  const fetchUsers = (ctx, callback) => {
    store
      .dispatch('saleOrderShop/fetchSaleOrders', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        role: roleFilter.value,
        plan: planFilter.value,
        status: statusFilter.value,

      })
      .then(response => {
        const { data, totalCount } = response

        callback(data)
        totalUsers.value = totalCount
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === true) return 'success'
    if (status === 'pending') return 'warning'
    if (status === 'active') return 'success'
    if (status === 'inactive') return 'secondary'
    return 'primary'
  }

  return {
    fetchUsers,
    tableColumns,
    tableProductColumn,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
  }
}
